"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValueOrNull = (value) => {
    return value ? value : null;
};
//# sourceMappingURL=get-value-or-null.js.map